import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { cancelPaymentRequestCode, cancelPaymentRequestCodeResponse } from "./TransactionRequestData/CancelPaymentRequestCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const CancelPaymentRequestComponent = () => {
    const [selectedLanguageCancelPaymentRequest, setSelectedLanguageCancelPaymentRequest] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageCancelPaymentRequest(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'cancelPaymentRequest' ? cancelPaymentRequestCode[selectedLanguageCancelPaymentRequest].request : cancelPaymentRequestCodeResponse;
        navigator.clipboard.writeText(textToCopy)
        .then(() => {
            setCopyStatus({ type, isCopied: true });
            setTimeout(() => {
                setCopyStatus({ type: '', isCopied: false });
            }, 1000);
        })
        .catch((error) => {
            console.error('Error copying text: ', error);
            alert('Failed to copy text. Please try again.');
        });
};


    return (
        <section className="docs-section" id="cancel-payment-request">

        <div className="row flexbox">

            <div className="col-md-5">
                <h2 className="section-heading">Cancel Payment Request</h2>
                <p><span className="badge badge-secondary back-green">POST</span><span className="api"> /in-store/api/v1/cancel</span></p>
                <p>Service to cancel purchase or refund requests</p>

                <h4>Request Body</h4>

                <div className="property-tab col-md-10 border-bottom">
                    <p required><span className="badge badge-secondary name">terminalId</span> &nbsp; &nbsp; <b>string</b></p>
                    <p className="description">Terminal ID</p>
                </div>

                <br />

                <div className="response-codes">

                    <h4>Response Codes</h4>

                    <div className="table-wrapper">

                        <h6 className="header">HTTP Status code summary</h6>

                        <table>
                            <tbody>
                                <tr>
                                    <td>201 Created</td>
                                    <td>Cancellation request is properly created and notified to terminal</td>
                                </tr>
                                <tr>
                                    <td>400 Bad Request</td>
                                    <td>Bad request format or validation failed for incorrect data formats</td>
                                </tr>
                                <tr>
                                    <td>401 Unauthorized</td>
                                    <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header</td>
                                </tr>
                                <tr>
                                    <td>409 Conflict</td>
                                    <td>A database operation may have caused a conflict</td>
                                </tr>
                                <tr>
                                    <td>422 Client Error</td>
                                    <td>Un-processable request. Most probably this happens when a validation error occurs while processing the cancellation request</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
            </div>

            <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(cancelPaymentRequestCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="langCancelPaymentRequest" id={`${language}CancelPaymentRequest`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageCancelPaymentRequest === language} />
                                                <label htmlFor={`${language}CancelPaymentRequest`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'cancelPaymentRequest' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("cancelPaymentRequest")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'cancelPaymentRequest' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageCancelPaymentRequest]} style={dracula} showLineNumbers>
                                        {cancelPaymentRequestCode[selectedLanguageCancelPaymentRequest].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'cancelPaymentRequestResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("cancelPaymentRequestResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'cancelPaymentRequestResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {cancelPaymentRequestCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>

        </div>

    </section>
    );
};


export default CancelPaymentRequestComponent;
